import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styles from './SingleOccupancyCard.module.scss'

Shared.propTypes = {
  numberOfProducts: PropTypes.number,
  roomTitle: PropTypes.string,
  numberOfGuests: PropTypes.number,
  sharedHandler: PropTypes.func.isRequired,
  setIsCollapsed: PropTypes.func.isRequired,
  priceSection: PropTypes.node,
}

export default function Shared({
  numberOfProducts,
  roomTitle,
  numberOfGuests,
  sharedHandler,
  setIsCollapsed,
  priceSection,
}) {
  return (
    <div className={styles.inner}>
      <div className={styles.body}>
        <p>
          {numberOfProducts === 1 && (
            <FormattedMessage
              id='default_occupancy'
              defaultMessage='The default occupancy for 1 guest in the {roomTitle} is'
              values={{ roomTitle }}
            />
          )}
          {numberOfProducts > 1 && (
            <FormattedMessage
              id='shared_occupacy_for_more'
              defaultMessage='You have chosen to book a trip for {numberOfGuests} guests. Given the maximum occupancy levels of the chosen cabin(s), 1 guest will be booked in a cabin with the option'
              values={{ numberOfGuests }}
            />
          )}
          &nbsp;
          <strong>
            <FormattedMessage defaultMessage='Shared occupancy.' />
          </strong>
        </p>
        {numberOfProducts === 1 && (
          <FormattedMessage
            id='for_one_guest_description'
            defaultMessage='This means that you will most likely be paired with another guest with whom you will share the cabin. That other guest may or may not be of the same gender as you.'
            tagName='p'
          />
        )}
        {numberOfProducts > 1 && (
          <FormattedMessage
            id='for_multi_guests_description'
            defaultMessage='This means that you will be paired with another guest of the same sex with whom you will share the cabin.'
            tagName='p'
          />
        )}
      </div>
      {priceSection}
      <div className={styles.actions}>
        <button
          type='button'
          className={styles.btnPrimary}
          onClick={() => sharedHandler(false)}
        >
          <FormattedMessage
            id='want_to_myself'
            defaultMessage='Yes I want the cabin to myself'
          />
        </button>
        <button
          type='button'
          className={styles.btnSecondary}
          onClick={() => setIsCollapsed(true)}
        >
          <FormattedMessage
            id='stay_with_sharing'
            defaultMessage="No thanks, I'm fine with sharing"
          />
        </button>
      </div>
    </div>
  )
}
